<template>
    <div>
        <div >
            <!--        <iframe src="http://146.56.193.165:9001/"></iframe>-->
<!--            <iframe :src="htmlContent"  class="iframe-container"  frameborder="0"  ref="myIframe"></iframe>-->
<!--            <iframe :src="htmlContent2"  class="iframe-container"  frameborder="0"  ref="myIframe"></iframe>-->
            <iframe :src="htmlContent2"  class="iframe-container"  frameborder="0"  ref="myIframe"></iframe>
            <hr>
<!--            <iframe :src="googleDocsPreviewUrl"  class="iframe-container"  frameborder="0"  ref="myIframe"></iframe>-->
<!--            <button @click="loadHtml" style="margin-bottom: 50px" >加载 HTML 文件</button>-->

            <!--            <div v-html="htmlContent" style="width: 200px;height: 200px"></div>-->
            <!--        <div class="abc">tttt</div>-->
        </div>

    </div>

</template>

<script>
import global_variable from "@/utils/global_variable";

    export default {
        name: "scratch",
        data() {
            return {
                loading:true,
                htmlContent: "http://146.56.193.165:9002/scratch/boy.html?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=SX6ob6RNVBVr6brPLmPQ%2F20250427%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20250427T123230Z&X-Amz-Expires=604800&X-Amz-SignedHeaders=host&X-Amz-Signature=1ce8c8ac73eaaa66b4c029ca81a7b9d5c724d6251715ade3f7bb499bd3d77fd6",
                htmlContent2: "",
            };
        },
        created() {
            this.htmlContent2 = `${global_variable.getProtocol()}//www.wancode.net:9002/scratch/tf.html?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=SX6ob6RNVBVr6brPLmPQ%2F20250428%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20250428T110456Z&X-Amz-Expires=604800&X-Amz-SignedHeaders=host&X-Amz-Signature=756abf1da128220f6eff08589793667bc64c6b2ffd45fd343fb7dc46bc514381`;
        },
        methods: {
            loadHtml() {
                window.open("/tf.html");
            }
        },
        computed: {
            googleDocsPreviewUrl() {
                return `https://docs.google.com/gview?url=${encodeURIComponent(this.htmlContent2)}&embedded=true`;
            }
        },
        mounted() {
            this.$refs.myIframe.addEventListener('load', () => {
                this.loading = false; // 当 iframe 加载完成后，关闭加载指示器
            });
        }
        // mounted() {
        //     // 在组件挂载完成后，获取 iframe 元素
        //     const iframe = this.$refs.myIframe;
        //     // 监听 iframe 的加载完成事件
        //     iframe.onload = () => {
        //         try {
        //             // 获取 iframe 的文档对象
        //             const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
        //             // 设置 iframe 文档的 body 背景颜色为透明
        //             iframeDoc.body.style.backgroundColor = 'transparent';
        //             // 设置 iframe 文档的背景颜色为透明
        //             iframeDoc.documentElement.style.backgroundColor = 'transparent';
        //         } catch (error) {
        //             // 若出现跨域问题，捕获并输出错误信息
        //             console.error('跨域问题，无法设置背景颜色:', error);
        //         }
        //     };
        // },
    }
</script>

<style scoped>
    .iframe-container {
        width: 750px;
        height: 600px;
        /*background-color: red;*/
        background-color: transparent !important;
    }

    .iframe-container {
        position: relative;
        /*width: 100%;*/
        /*height: 100%;*/
    }

    .transparent-iframe {
        /*width: 100%;*/
        /*height: 100%;*/
        background: transparent;
        border: none;
    }

</style>
